import React from 'react';
import { PEIImage, PEILink } from '@/common';
import { brandFooterData, footerBottomNavigation, socialLinks } from '@/common';
import styles from '@/styles/Footer.module.scss';
import { URL } from '@/utils';
const { basePEIURL, brandURL } = URL;

export const Footer = () => {
  return (
    <footer className={styles.footer} id='footer'>
      <div className={styles['footer-container']}>
        <div className={styles['Pei-icons']}>
          <div className={styles['Pei-icon']}>
            <PEILink href={brandURL} target='_self'>
              <PEIImage
                src={'./pei-group.png'}
                alt='brand icon'
                width={300}
                height={300}
                className={styles.peiLogo}
              />
            </PEILink>
          </div>
          <div className={styles['social-media']}>
            {socialLinks.linkedIn && <PEILink href={socialLinks.linkedIn} target='_blank' className={styles.linkSocial}>
              <i className={`${styles['td-icon-linkedin']} ${styles['td-icon']}`} />
            </PEILink>}
            {socialLinks.twitter && (
              <PEILink href={socialLinks.twitter} target='_blank' className={styles.linkSocial}>
                <i className={`${styles['td-icon-twitter']} ${styles['td-icon']}`} />
              </PEILink>
            )}
          </div>
        </div>

        <div className={styles.container}>
          <div className={styles.brandContainer}>
            <ul className={styles.brandul}>
              {brandFooterData.map((data: { name: string; url: string }) => {
                return (
                  <li key={data.name}>
                    <a href={data.url} target='_blank' className={styles.brandsli} rel='noreferrer'>
                      {data.name}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className={styles['social-links']}>
            <div className={styles['Pei-group']}>
              <a> &copy; PEI Group</a>
            </div>
            <div className={styles.bottomlogo}>
              <PEIImage
                src={'./pei-group.png'}
                alt='brand icon'
                width={300}
                height={300}
                onClick={() => {
                  window.open(brandURL, '_self');
                }}
                className={`${styles['social-media-links']} ${styles.peiLogo} `}
              />
            </div>
            <div className={styles['links']}>
              {footerBottomNavigation.map((nav) => (
                <a key={nav.name} href={nav.link} target='_blank' rel='noreferrer'>
                  {nav.name}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
